import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Website} from "../../../website";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {CloudflareService} from "../../services/cloudflare.service";
import {UserSubscription, UserSubscriptionCategory} from '../../../../../user/user-subscription';
import {User} from '../../../../../user/user';
import features from '../cdn-disabled/cdn-features.json';
import {DbModalService} from "../../../../../modules/modal/modal";
import {Subject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {filter, first, takeUntil} from "rxjs/operators";
import {PerformanceService} from "../../../performance/performance.service";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {ConfirmDialogComponent} from "../../../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {BoosterMode} from "../../services/booster.service";

interface IFeature {
  img?: any;
  title: string;
  desc: string;
}

interface IPageSpeedData {
  title: string;
  withoutCDN: string | number;
  withCDN: string;
}

interface IReviews {
  text: string;
  author: string;
}

interface IFaqs {
  title: string;
  desc: any;
  img?: string;
}

interface ISlider {
  title: string;
  desc: any;
  tab: string;
  id: number;
}

@Component({
    selector: 'db-cdn-test',
    templateUrl: './cdn-test.component.html',
    styleUrls: ['./cdn-test.component.scss'],
    standalone: false
})
export class CdnTestComponent implements OnInit {

  @Input() currentSubscription: UserSubscription;
  @ViewChild('testCDNVideo') testCDNVideo: ElementRef<HTMLVideoElement>;

  public boosterMode: BoosterMode;
  public website: Website;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public features: IFeature[];
  public siteUrl: string;
  public user: User;
  public options: any;
  public showDesc: number;
  public pageLoadTime: number;
  public pageScore: number;
  public dataLoading: boolean = true;
  public pageSpeedData: IPageSpeedData[];
  public impactFeatures: string[];
  public reviews: IReviews[];
  public faqs: IFaqs[];
  public slider: ISlider[];
  public activeSlide: number = 0;
  public copied: boolean = false;
  public testCdnCreated: boolean = false;
  public loading: boolean = false;
  public pageLoading: boolean = false;
  public optimizedCDNUrl: string;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dbModalService: DbModalService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cloudflareService: CloudflareService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _dialogService: DialogService,
    private _modalService: DbModalService,
    private _performanceService: PerformanceService
  ) {
  }

  ngOnInit() {
    this.website = this._route.snapshot.parent.parent.data['website'];
    this._store.select(fromStore.getWebsiteBoosterModeLevel(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(modeLevel => {
        if (!TypeUtils.isNull(modeLevel))  {
          this.boosterMode = modeLevel;
        }
      });
    this.getTestCdnPage();
    this.faqs = features.boosterFree;
    this.slider = [
      {
        title: '4% increase in conversion rates',
        desc: 'Faster load times can positively impact conversion rates for e-commerce<br/>websites, leading to increased sales and revenue. It also<br/>impacts all your other goals like lead generation, completed signups<br/>and more. Higher conversion rates result in a better return on<br/>investment for your marketing efforts.',
        tab: 'Increased conversion rate',
        id: 0
      },
      {
        title: 'Reduced bounce rate',
        desc: 'Slow load times decrease your website engagement rates as users<br/>quickly leave a website if it takes too long to load. A faster load time<br/>can reduce bounce rates and keep users on the site longer.',
        tab: 'Reduced bounce rate',
        id: 1
      },
      {
        title: 'Better SEO ranking',
        desc: 'The higher your website loading speed, the higher are your chances to<br/>rank high on Google. Low TTFB can result in an increased traffic to your<br/>website as more users will see and click on your site in search results.',
        tab: 'Better SEO ranking',
        id: 2
      }
    ];
    this.impactFeatures = ['We will create a copy of your<br/>homepage in 2 minutes', 'The copy will be stored on our servers<br/>with CDN to show you the improvement', 'It will not affect the original version<br/>and be deleted in 1 day'];
    this.reviews = [
      {
        text: "10web.io is really good especially its pro version.<br/>Thanks for good support website is now<br/>working really nice.",
        author: "Asilbek"
      },
      {
        text: "love the system highly recommended for every<br/>type of businesses. The price is extremely<br/>affordable, keep up the excellent job.",
        author: "Emma"
      }
    ];
    let scoreWithoutCDN = this.website && this.website.score && this.website.score.currentScore && this.website.score.currentScore.mobileScore;
    scoreWithoutCDN == 101 && (scoreWithoutCDN = 100);
    this.pageSpeedData = [
      {
        title: 'PageSpeed score',
        withoutCDN: scoreWithoutCDN,
        withCDN: 'Up to 30%<br/>improvement'
      },
      {
        title: 'TTFB',
        withoutCDN: '600ms',
        withCDN: '<100ms*'
      },
      {
        title: 'Page load time',
        withoutCDN: this.website && this.website.score && this.website.score.currentScore && this.website.score.currentScore.mobileTTI + 's',
        withCDN: 'Up to 50%<br/> improvement'
      }
    ];
    this.options = [
      {
        img: "assets/images/icons/speed-green.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong1'),
      },
      {
        img: "assets/images/icons/speed-time.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong2'),
      },
      {
        img: "assets/images/icons/speed-globe.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong3'),
      }
    ];
    this.currentSubscription && this.currentSubscription.trialBoosterClient ? this.features = features.boosterFree : this.features = features.paid;
    this.website && this._store.select(fromStore.getWebsite(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(website => !!website)
      )
      .subscribe((website: Website) => {
        this.website = website;
        this.pageLoadTime = this.website ? this.website.score && this.website.score.currentScore && (this.website.score.currentScore.desktopTTI >
        this.website.score.currentScore.mobileTTI ? this.website.score.currentScore.desktopTTI : this.website.score.currentScore.mobileTTI) : null;
        this.pageScore = this.website ? this.website.score && this.website.score.currentScore && (this.website.score.currentScore.desktopScore >
        this.website.score.currentScore.mobileScore ? this.website.score.currentScore.mobileScore : this.website.score.currentScore.desktopScore) : null;
        this.dataLoading = false;
        this.siteUrl = this.website && this.website.site_url.replace(/(^\w+:|^)\/\//, '') || '';
      });
  }

  public playVideo(): void {
    this.testCDNVideo.nativeElement.muted = true;
    this.testCDNVideo.nativeElement.play();
  }
  public getTestCdnPage() {
    this.pageLoading = true;
    this._performanceService.getTestCdnPage(this.website?.id)
      .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success && response.data) {
          if (response.data.TTFBOptimizedData) {
            this.pageSpeedData[0].withCDN = 'Improved';
            this.pageSpeedData[1].withCDN = response.data.TTFBOptimizedData
              && Math.ceil(response.data.TTFBOptimizedData.ttfb).toString() + 'ms';
            this.pageSpeedData[2].withCDN = 'Improved';
            this.optimizedCDNUrl = response.data.optimizedSiteUrl;
            this.testCdnCreated = true;
          }
          if (response.data.TTFBOriginalData) {
            this.pageSpeedData[1].withoutCDN = response.data.TTFBOriginalData && Math.ceil(response.data.TTFBOriginalData.ttfb).toString() + 'ms';
            this.pageLoading = false;
          }
          else {
            this.createTestCdnPage();
          }
        }
        else {
          this.createTestCdnPage();
        }
      });
  }

  public createTestCdnPage() {
    this._performanceService.createTestCdnPage(this.website?.id, this.website?.site_url)
      .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success && response.data && response.data.TTFBOriginalData) {
          this.pageSpeedData[1].withoutCDN = response.data.TTFBOriginalData && Math.ceil(response.data.TTFBOriginalData.ttfb).toString() + 'ms';
        }
        this.pageLoading = false;
      });
  }

  public generateTestCdnPage(testAgain = false) {
    this.loading = true;
    this._performanceService.generateTestCdnPage(this.website?.id, this.website?.site_url, this.boosterMode)
      .pipe(filter((response: DbResponse) => !!response),
        first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          if (response.data && response.data.ttfb_data && response.data.ttfb_data.TTFBOriginalData) {
            this.pageSpeedData[1].withoutCDN = response.data && response.data.ttfb_data && response.data.ttfb_data.TTFBOriginalData && Math.ceil(response.data.ttfb_data.TTFBOriginalData.ttfb).toString() + 'ms';
          }
          if (response.data && response.data.ttfb_data && response.data.ttfb_data.TTFBOptimizedData) {
            this.pageSpeedData[0].withCDN = 'Improved';
            this.pageSpeedData[1].withCDN = response.data && response.data.ttfb_data
              && response.data.ttfb_data.TTFBOptimizedData && Math.ceil(response.data.ttfb_data.TTFBOptimizedData.ttfb).toString() + 'ms';
            this.pageSpeedData[2].withCDN = 'Improved';
          }
          this.optimizedCDNUrl = response.data.new_url;
          this.testCdnCreated = true;
        }
        else {
          this.showFailedDialog();
        }
        this.loading = false;
      });
  }

  public showFailedDialog() {
    this._dialogService.addDialog(ConfirmDialogComponent, {
      header: TextUtils.getText('text_somethingWentWrong'),
      message: TextUtils.getText('text_testCdnGenerateFail'),
      confirmButtonText: TextUtils.getText('text_retry'),
      confirmButtonClass: 'ds-btn-blue rectangle'
    }).subscribe(confirmed => {
      if (confirmed) {
        this.generateTestCdnPage();
      }
    });
  }

}
